import { converters } from "../mixins/converters";
import { EventBus } from "../src/eventBus";
import moment from "moment";

export const StoreTypeTabNC = {
	mixins: [converters],
	data() {
		return {
			map: [],
			mainHeadings: [],
			subHeadings: [],

			tableRows: [],

			headings: [
				{ value: "Store Name", colspan: 1, isBorder: true },
				{ value: "ADT", colspan: 1, isBorder: true },
				{ value: "Txns", colspan: 1, isBorder: true },
				{ value: "Labour Hours", colspan: 1, isBorder: true },
				{ value: "ADT", colspan: 1, isBorder: true },
				{ value: "Txns", colspan: 1, isBorder: true },
				{ value: "Labour Hours", colspan: 1, isBorder: true },
				{ value: "Target", colspan: 1, isBorder: true },
				{ value: "Achievement", colspan: 1, isBorder: true },
				{ value: "Achievement%", colspan: 1, isBorder: true }
			],
			contributonViewHeadings: [
				{ value: "Store Name", colspan: 1, isBorder: true },
				{ value: "ADT", colspan: 2, isBorder: true },
				{ value: "Txns", colspan: 2, isBorder: true },
				{ value: "Labour Hours", colspan: 2, isBorder: true },
				{ value: "ADT", colspan: 1, isBorder: true },
				{ value: "Txns", colspan: 2, isBorder: true },
				{ value: "Labour Hours", colspan: 1, isBorder: true },
				{ value: "Target", colspan: 1, isBorder: true },
				{ value: "Achievement", colspan: 1, isBorder: true },
				{ value: "Achievement%", colspan: 1, isBorder: true }
			],
			headingMain: [
				{ value: "", colspan: 1, isBorder: false },
				{ value: "Achievement", colspan: 3, isBorder: true },
				{ value: "Forecast", colspan: 3, isBorder: true },
				{ value: "IPLH", colspan: 3, isBorder: true }
			],
			contributionViewHeadingsMain: [
				{ value: "Achievement", colspan: 4, isBorder: true },
				{ value: "Forecast", colspan: 3, isBorder: true },
				{ value: "IPLH", colspan: 4, isBorder: true }
			],
			subHeading: [
				{ value: "", colspan: 1, isBorder: true },
				{ value: "quantity", colspan: 1, isBorder: true },
				{ value: "%", colspan: 1, isBorder: true },
				{ value: "quantity", colspan: 1, isBorder: true },
				{ value: "%", colspan: 1, isBorder: true },
				{ value: "quantity", colspan: 1, isBorder: true },
				{ value: "%", colspan: 1, isBorder: true },
				{ value: "", colspan: 1, isBorder: true },
				{ value: "quantity", colspan: 1, isBorder: true },
				{ value: "%", colspan: 1, isBorder: true },
				{ value: "", colspan: 1, isBorder: true },
				{ value: "", colspan: 1, isBorder: true },
				{ value: "", colspan: 1, isBorder: true }
			],
			tableData: {
				data: {
					mainHeadings: [],
					subHeadings: [],
					tableRows: [],
					headingMain: [],
					headings: [],
					subHeading: [],
					rows: []
				}
			},
			basicsMapping: {
				country: "Country Name",
				state: "State Name",
				region: "Region Name",
				subregion: "Subregion Name",
				outlet: "Store Name",
				department: "Department Name",
				category: "Category Name",
				subcategory: "Subcategory Name",
				product: "Product Name"
			}
		};
	},
	methods: {
		AnalyticsDataCallBack(analyticsDataResponse, consolidatedDataResponse) {
			if (analyticsDataResponse.length && consolidatedDataResponse.length) {
				EventBus.$emit("disableFirstButton", false);
				this.tableData.data.tableRows = [];
				this.tableRows = [];
				this.fillConsolidatedData(consolidatedDataResponse);
				this.fillOutletsData(analyticsDataResponse);
				console.log('this.tableData', this.tableData);
				this.$store.commit("setAnalyticsData", this.tableData);

				// extract data for graph
				const graphData = this.getReportGraphData(analyticsDataResponse);
				graphData.selectSalesView = this.selectSalesView;

				// emit an event to call rerender function in woowgraph componenent
				setTimeout(() => {
					EventBus.$emit("getGraphDetails", graphData);
				}, 0);

			}else{
				this.$store.commit("setAnalyticsData", {});
			}
		},

		async getQueryReportsNetworkCallBack(queryResponse1, queryResponse2) {
			if (Object.keys(queryResponse1).length && queryResponse1.results.length) {
				this.$store.commit("setGraphData", []);
				this.tableData.data.tableRows = [];
				this.tableRows = [];

				this.fillConsolidatedData(queryResponse2.results);
				this.fillOutletsData(queryResponse1.results);
				this.tableData.data.subHeadings = [];

				for (let i = 0; i < queryResponse1.results.length; i++) {
					for (var key in queryResponse1.results[i]) {
						let headingObj = {
							value: "Store Name",
							colspan: 1,
							isBorder: true
						};

						this.tableData.data.subHeadings.push(headingObj); //pushed initially store name as first header
						for (const nestedKey in queryResponse1.results[i][key]) {
							if (nestedKey != "name") {
								//push date in subHeadings when object key is not "name" string
								let obj = {};
								obj.value = moment(nestedKey).format("DD MMM YY");
								obj.colspan = 1;
								obj.isBorder = true;
								this.tableData.data.subHeadings.push(obj); //pushed next headers
							}
						}
					}
					break;
				}
				EventBus.$emit("disableFirstButton", false);
				const graphData = this.getReportGraphData(
					queryResponse1.results,
					queryResponse2.results
				);

				// graphData.selectSalesView = this.selectSalesView;
				// EventBus.$emit("getGraphData", graphData);
				graphData.selectSalesView = this.selectSalesView;
				setTimeout(() => {
					// emit an event to call rerender function in woowgraph componenent
					EventBus.$emit("getGraphDetails", graphData);
				}, 0);

				this.$store.commit("setAnalyticsData", this.tableData);
				console.log('this.tableData', this.tableData);


			} else {
				this.$store.commit("setAnalyticsData", {});
			}
		},

		fillConsolidatedData(consolidatedData) {
			let initialHeader = {
				label: "Consolidated",
				data: []
			};
			this.tableRows.push(initialHeader);
			for (var i = 0; i < this.tableRows.length; i++) {
				if (this.tableRows[i].label == "Consolidated") {
					if (this.quickReports == "wfr" && this.selectSalesView == 'iplh') {
						this.tableRows[i].data.push(
							consolidatedData[0][1].forecast_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].forecast_iplh);
						this.tableRows[i].data.push(
							consolidatedData[0][1].sheduled_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].sheduled_iplh);
						this.tableRows[i].data.push(
							consolidatedData[0][1].actual_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].actual_iplh);
						this.tableRows[i].data.push(consolidatedData[0][1].act_vs_for);
						this.tableRows[i].data.push(consolidatedData[0][1].act_vs_shed);
						// this.tableRows[i].data.push(consolidatedData[0][1]["diff%"]);
					} else if (
						this.quickReports == "day" ||
						this.quickReports == "week" ||
						this.quickReports == "month"
					) {
						for (let item in consolidatedData[i][1]) {
							this.tableRows[i].data.push(consolidatedData[i][1][item]); //pushed data in table row
						}
					} else if (
						this.quickReports == "wfr" &&
						this.selectSalesView == "variance"
					) {
						this.tableRows[i].data.push(
							consolidatedData[0][1].forecast_labour_hours
						);
						this.tableRows[i].data.push(
							consolidatedData[0][1].sheduled_labour_hours
						);
						this.tableRows[i].data.push(
							consolidatedData[0][1].actual_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].wastage_hours);
						this.tableRows[i].data.push(
							consolidatedData[0][1].variance_to_ideal
						);
						this.tableRows[i].data.push(
							consolidatedData[0][1].variance_to_total
						);
					} else if (
						this.quickReports == "wfr" &&
						this.selectSalesView == "tplh"
					) {
					
						this.tableRows[i].data.push(
							consolidatedData[0][1].forecast_transaction
						);
						this.tableRows[i].data.push(
							consolidatedData[0][1].forecast_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].forecast_tplh);
						this.tableRows[i].data.push(
							consolidatedData[0][1].forecast_transaction
						);
						this.tableRows[i].data.push(
							consolidatedData[0][1].sheduled_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].actual_trans);
						this.tableRows[i].data.push(
							consolidatedData[0][1].actual_labour_hours
						);
						this.tableRows[i].data.push(consolidatedData[0][1].actual_tplh);
						this.tableRows[i].data.push(consolidatedData[0][1].sheduled_tplh);
						this.tableRows[i].data.push(consolidatedData[0][1].act_vs_for);
					}
				}
			}
			this.tableData.data.tableRows = this.tableRows;
		},

		fillOutletsData(outletsData) {
			console.log('outletsData', this.storeMappings);
			if(this.storeMappings.length){
				for (let i = 0; i < outletsData.length; i++) {
					for (var key in outletsData[i]) {
						for (var j = 0; j < this.storeMappings.length; j++) {
							if (this.storeMappings[j].id == key) {
								outletsData[i][key].name = this.storeMappings[j].name;
							}
						}
					}
				} //set outlets name in response
			}

			for (var i = 0; i < outletsData.length; i++) {
				let rowObj = {};
				rowObj.data = [];
				for (let key in outletsData[i]) {
					// console.log('fillOutletsData', outletsData[i])
					rowObj.id = key; //set id of outlet
					rowObj.label = outletsData[i][key].name ? outletsData[i][key].name : key; //set name of outlet
					rowObj.basics = this.basics; //create basics key in rowObject

					if (this.quickReports == "wfr" && this.selectSalesView == "iplh") {
						// checked quick reports type and then filled data in table row
						rowObj.data.push(outletsData[i][key].forecast_labour_hours);
						rowObj.data.push(outletsData[i][key].forecast_iplh);
						rowObj.data.push(outletsData[i][key].sheduled_labour_hours);
						rowObj.data.push(outletsData[i][key].sheduled_iplh);
						rowObj.data.push(outletsData[i][key].actual_labour_hours); //pushed data in table row
						rowObj.data.push(outletsData[i][key].actual_iplh);
						rowObj.data.push(outletsData[i][key].act_vs_for);
						rowObj.data.push(outletsData[i][key].act_vs_shed);
						// rowObj.data.push(outletsData[i][key]["diff%"]);
					} else if (
						this.quickReports == "day" ||
						this.quickReports == "week" ||
						this.quickReports == "month"
					) {
						for (let item in outletsData[i][key]) {
							if (item != "name") {
								//checked if name key is present
								rowObj.data.push(outletsData[i][key][item]); //pushed data in table rowtableData
							}
						}
					} else if (
						this.quickReports == "wfr" &&
						this.selectSalesView == "variance"
					) {
						rowObj.data.push(outletsData[i][key].forecast_labour_hours);
						rowObj.data.push(outletsData[i][key].sheduled_labour_hours);
						rowObj.data.push(outletsData[i][key].actual_labour_hours);
						rowObj.data.push(outletsData[i][key].wastage_hours);
						rowObj.data.push(outletsData[i][key].variance_to_ideal);
						rowObj.data.push(outletsData[i][key].variance_to_total);
					} else {
						if (this.quickReports == "wfr" && this.selectSalesView == "tplh") {
							// checked selectSalesView tplh and then filled data in table row
							rowObj.data.push(outletsData[i][key].forecast_transaction);
							rowObj.data.push(outletsData[i][key].forecast_labour_hours);
							rowObj.data.push(outletsData[i][key].forecast_tplh);
							rowObj.data.push(outletsData[i][key].forecast_transaction);
							rowObj.data.push(outletsData[i][key].sheduled_labour_hours);
							rowObj.data.push(outletsData[i][key].sheduled_tplh);
							rowObj.data.push(outletsData[i][key].actual_trans); //pushed data in table row
							rowObj.data.push(outletsData[i][key].actual_labour_hours);
							rowObj.data.push(outletsData[i][key].actual_tplh);
							rowObj.data.push(outletsData[i][key].act_vs_for);
						}
					}
				}

				this.tableRows.push(rowObj);
				this.tableData.data.tableRows = this.tableRows;
			}
		},

		getReportGraphData(storeResponse, consolidatedData) {
			var result = {
				reportsType: this.quickReports,
				xAxisData: [],
				series: {
					achivedTransactions: [],
					achivedIplh: [],
					targetIplh: []
				}
			};
			if (this.quickReports == "wfr" && this.selectSalesView == "iplh") {
				var result = {
					reportsType: this.quickReports,
					xAxisData: [],
					series: {
						actualIplh: [],
						forecastIplh: []
					}
				};
				for (var i = 0; i < storeResponse.length; i++) {
					const keysArray = Object.keys(storeResponse[i]); //returns keys e.g. store types Airport, mall
					//concats the return array(keyNames) to existing array result.xAxisData
					result = keysArray.reduce((keyNames, key) => {
						result.xAxisData.push(key);
						result.series.actualIplh.push(storeResponse[i][key]["actual_iplh"]);
						result.series.forecastIplh.push(
							storeResponse[i][key]["forecast_iplh"]
						);

						return result;
					}, result);
					// console.log("result", result);
				}
			} else if (
				this.quickReports == "wfr" &&
				this.selectSalesView == "variance"
			) {
				var result = {
					reportsType: this.quickReports,
					xAxisData: [],
					series: {
						actualLabourHours: [],
						forecastLabourHours: [],
						scheduledLabourHours: []
					}
				};
				for (var i = 0; i < storeResponse.length; i++) {
					const keysArray = Object.keys(storeResponse[i]); //returns keys e.g. store types Airport, mall
					result = keysArray.reduce((keyNames, key) => {
						// console.log(keyNames)
						result.xAxisData.push(key); //pushed key as store type names
						result.series.actualLabourHours.push(
							storeResponse[i][key]["actual_labour_hours"]
						);
						result.series.forecastLabourHours.push(
							storeResponse[i][key]["forecast_labour_hours"]
						);
						result.series.scheduledLabourHours.push(
							storeResponse[i][key]["sheduled_labour_hours"]
						);
						return result;
					}, result);
				}
			} else if (this.quickReports == "wfr" && this.selectSalesView == "tplh") {
				var result = {
					reportsType: this.quickReports,
					xAxisData: [],
					series: {
						actualTplh: [],
						forecastTplh: []
					}
				};
				for (var i = 0; i < storeResponse.length; i++) {
					const keysArray = Object.keys(storeResponse[i]); //returns keys e.g. store types Airport, mall
					result = keysArray.reduce((keyNames, key) => {
						result.xAxisData.push(key); //pushed key as store type name
						result.series.actualTplh.push(storeResponse[i][key]["actual_tplh"]);
						result.series.forecastTplh.push(
							storeResponse[i][key]["forecast_tplh"]
						);
						return result;
					}, result);
				}
			} else {
				//cleared seriers to fill dynamic series accroding to storeResponse
				result.series = {};
				result.series.storeData = [];
				result.series.consolidatedData = [];

				for (let i = 0; i < consolidatedData.length; i++) {
					//for filling consolidated data in graph series and xaxis
					for (var key in consolidatedData[i]) {
						for (var nestedKey in consolidatedData[i][key]) {
							let arr = [];
							result.xAxisData.push(moment(nestedKey).format("YYYY-MM-DD")); //filled xaxis
							arr = consolidatedData[i][key][nestedKey];
							result.series.consolidatedData.push(arr);
						}
					}
				}

				for (let i = 0; i < storeResponse.length; i++) {
					let obj = {
						name: "",
						data: []
					};

					for (var key in storeResponse[i]) {
						obj.name = key;
						for (var nestedKey in storeResponse[i][key]) {
							obj.data.push(storeResponse[i][key][nestedKey]);
						}
					}
					result.series.storeData.push(obj);
				}
			}
			return result;
		}
	}
};
